import React from 'react';
import { useTranslation } from 'react-i18next';
import { Input } from 'reactstrap';

import translations from 'services/translations/translations';

import useOfferDepartments from './useOfferDepartments';

/** The offers of one department or of all departments the user can see. */
const DepartmentSelect = ({
  bsSize,
  className,
  onChange,
  value,
}: {
  bsSize?: 'lg' | 'sm';
  className?: string;
  // The id of the department, '' for all
  onChange: (value: string) => void;
  value: string;
}): JSX.Element => {
  const { t } = useTranslation([translations.offers]);
  const departments = useOfferDepartments();

  return (
    <Input
      aria-label={t(`${translations.offers}:positionSearch.Organization unit`)}
      bsSize={bsSize}
      className={className}
      onChange={(event) => onChange(event.target.value)}
      type="select"
      value={value}
    >
      <option value="">
        {t(`${translations.offers}:positionSearch.All departments`)}
      </option>
      {departments.map((department) => (
        <option key={department.id} value={String(department.id)}>
          {department.name}
        </option>
      ))}
    </Input>
  );
};

export default DepartmentSelect;
